import {
  Box,
  CheckIcon,
  CloseIcon,
  CopyIcon,
  EditIcon,
  GKButton,
  GKTextField,
  Grid2,
  IconButton,
  RightIcon,
  Show,
  SimpleLoader,
  Typography,
} from "components";
import { useState } from "react";
import { Controller, FormProvider, useForm } from "react-hook-form";
import {
  useGetMutualFundEmailQuery,
  useUpdateAdvisorAutoForwardMutation,
} from "store/features/SettingsApi";
import ViewStepsModal from "./ViewStepsModal";

const MutualFundAutoImportSettings = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [openStepsModal, setOpenStepsModal] = useState(false);

  const { data, isFetching } = useGetMutualFundEmailQuery();
  const [updatePassword, { isLoading }] = useUpdateAdvisorAutoForwardMutation();

  const form = useForm({
    defaultValues: {
      email: "",
      password: "",
    },
    values: data?.data,
  });

  if (isFetching) return <SimpleLoader />;

  return (
    <FormProvider {...form}>
      <form
        onSubmit={form.handleSubmit(async (values) => {
          try {
            await updatePassword(values).unwrap();
          } catch (error) {
            console.log(error);
          }
        })}
      >
        <Grid2 container spacing={2}>
          <Grid2 size={6}>
            <Controller
              name="email"
              control={form.control}
              render={({ field }) => (
                <GKTextField
                  {...field}
                  inputLabel={"Email"}
                  slotProps={{
                    input: {
                      readOnly: true,
                      endAdornment: (
                        <IconButton
                          onClick={() => {
                            navigator.clipboard.writeText(`${field.value}`);
                          }}
                        >
                          <CopyIcon />
                        </IconButton>
                      ),
                    },
                  }}
                />
              )}
            />
          </Grid2>
          <Grid2 size={6}>
            <Controller
              name="password"
              control={form.control}
              render={({ field }) => (
                <GKTextField
                  {...field}
                  disabled={!isEditing}
                  inputLabel={"Password"}
                  placeholder="Enter Password"
                  slotProps={{
                    input: {
                      endAdornment: isEditing ? (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <IconButton
                            color="success"
                            onClick={() => setIsEditing(false)}
                          >
                            <CheckIcon />
                          </IconButton>
                          <IconButton
                            color="error"
                            onClick={() => setIsEditing(false)}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Box>
                      ) : (
                        <IconButton onClick={() => setIsEditing(true)}>
                          <EditIcon />
                        </IconButton>
                      ),
                    },
                  }}
                />
              )}
            />
          </Grid2>
          <Grid2 size={12}>
            <Typography
              display={"flex"}
              alignItems={"center"}
              color="var(--neutral-500)"
              fontWeight={400}
              fontSize={12}
              sx={{ cursor: "pointer" }}
              onClick={() => setOpenStepsModal(true)}
            >
              Configure Steps
              <RightIcon />
            </Typography>
          </Grid2>

          <Grid2 size={12} display={"flex"} justifyContent={"flex-end"}>
            <GKButton type="submit" variant="contained" loading={isLoading}>
              Save
            </GKButton>
          </Grid2>

          <Show.When isTrue={openStepsModal}>
            <ViewStepsModal open={openStepsModal} setOpen={setOpenStepsModal} />
          </Show.When>
        </Grid2>
      </form>
    </FormProvider>
  );
};

export default MutualFundAutoImportSettings;
